export default __webpack_public_path__ + "static/media/inventory_icon.009ded7a.svg";